<template>
  <div class="text-center mt-28">
    <v-progress-circular indeterminate color="green"></v-progress-circular>
    Processing payment...
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Axios from 'axios';
import { db } from '@/db';
import common from '../../mixins/common';
import { cloudFunctionsBackoffice } from '../../config';
import stripeHelper from '../../mixins/stripe-helper';

export default {
  name: 'stripe-process',

  mixins: [common, stripeHelper],

  computed: {
    ...mapState(['user_data', 'userType']),
  },

  methods: {
    async closePayment() {
      const { redirect_status, payment_intent, payment_intent_client_secret } =
        this.$route.params;

      if (redirect_status === 'succeeded') {
        const waitingPaymentData = await db
          .collection('payments_waiting')
          .doc(payment_intent_client_secret)
          .get({ source: 'server' })
          .then((snapshot) => snapshot.data());

        if (waitingPaymentData) {
          const batch = db.batch();

          // update user swipes in firesotre
          const refLoggedUser = db.collection(this.userType).doc(this.user_data.id);

          if (this.userType === 'teams') {
            const saisonEndMonth = 6;
            const currentMonth = new Date().getMonth() + 1;
            const currentYear = new Date().getFullYear();
            const saisonEnd =
              currentMonth > saisonEndMonth ? currentYear + 1 : currentYear;

            batch.update(refLoggedUser, {
              leaguePackage: {
                activeToDate: saisonEnd,
                paid: +waitingPaymentData.plan_details.promoPrice.replace('.', ''),
                boughtAt: Date.now(),
                boughtFor: this.getRestSeisonTime(),
                paidBy: waitingPaymentData.payment_type,
              },
            });
          } else {
            batch.update(refLoggedUser, {
              swipesLeft: waitingPaymentData.plan_details.swipes,
            });
          }

          // save payment in firestore
          const newPaymentRef = db.collection('payments').doc();
          batch.set(newPaymentRef, {
            stripe_payment_id: payment_intent,
            account_type: this.userType,
            account_id: this.user_data.id,
            plan_details: waitingPaymentData.plan_details,
            payment_method: waitingPaymentData.payment_type,
            timestamp: Date.now(),
          });

          // run batch
          batch
            .commit()
            .then(async () => {
              const data = {
                amount: Math.round(waitingPaymentData.plan_details.value / 100).toFixed(
                  2,
                ),
                email: this.user_data.email,
                affiliateId: this.user_data.affilliateID,
                ...waitingPaymentData,
              };

              await Axios({
                method: 'post',
                url: `${cloudFunctionsBackoffice}/newPayment`,
                headers: {
                  'content-type': 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
                data: JSON.stringify(data),
              });

              this.$store.commit({
                type: 'openSnackbar',
                text:
                  this.userType === 'teams'
                    ? 'Das Saisonticket ist jetzt aktiviert.'
                    : 'Dein Swipe-Package ist jetzt aktiv.',
              });

              this.redirectToUserType();
            })
            .catch((err) => {
              this.$store.commit({
                type: 'openSnackbar',
                text: 'Ups, da ist etwas schief gelaufen',
              });

              this.redirectToUserType();
              console.log({ err });
            });
        } else {
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Ups, keine Transaktion gefunden',
          });

          this.redirectToUserType();
        }
      } else {
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Ups, Transaktion abgelehnt.',
        });

        this.redirectToUserType();
      }
    },
  },

  created() {
    console.log('stripe success', this.$route);
    this.closePayment();
  },
};
</script>

<style scoped></style>
